export const triggerPDFDownload = (base64PDFContent: string, downloadFileName: string) => {
  // Format the base64 data into a downloadable file
  let a = document.createElement("a");
  a.href = "data:application/octet-stream;base64," + base64PDFContent;
  a.download = `${downloadFileName}.pdf`;
  a.click();
};
